import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GuestGuard } from '../../../core/guards/guest.guard';
import { IsDesktopGuard } from '../../../core/guards/is-desktop.guard';
import { PrepMIRGuard } from '../../../core/guards/prepmir.guard';
import { PrepSSMGuard } from '../../../core/guards/prepssm.guard';

import { PricingPremiumComponent } from '../../../shared/components/pricing-premium/pricing-premium.component';

import { SharedModule } from '../../../shared/shared.module';
import { CguComponent } from './legal/cgu/cgu.component';
import { CgvComponent } from './legal/cgv/cgv.component';
import { ConfidentialityComponent } from './legal/confidentiality/confidentiality.component';
import { LegalComponent } from './legal/legal.component';
import { MentionsComponent } from './legal/mentions/mentions.component';
import { PricingPublicComponent } from './pricing-public/pricing-public.component';
import { PublicFooterComponent } from './public-footer/public-footer.component';
import { RegisterFromLandingComponent } from './register-from-landing/register-from-landing.component';
import { PublicTestimoniesComponent } from './public-testimonies/public-testimonies.component';
import { LandingV2Component } from './landing-v2/landing-v2.component';
import { environment } from '../../../../environments/environment';
import { LandingPassComponent } from './landing-pass/landing-pass.component';
import { LandingPassFaqComponent } from './landing-pass/landing-pass-faq/landing-pass-faq.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: environment.app_type === 'default' ? LandingV2Component : LandingPassComponent,
        canActivate: [IsDesktopGuard, GuestGuard],
      },
      {
        path: 'home/:id',
        component: environment.app_type === 'default' ? LandingV2Component : LandingPassComponent,
        canActivate: [IsDesktopGuard, GuestGuard],
      },
      {
        path: 'pae',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'pae/:id',
        redirectTo: 'home/:id',
        pathMatch: 'full',
      },
      {
        path: 'legal',
        component: LegalComponent,
        children: [
          {
            path: '',
            redirectTo: 'cgu',
            pathMatch: 'full',
          },
          {
            path: 'cgu',
            component: CguComponent,
            data: {
              fullWidthNav: true,
              navbarTitleKey: 'cgu.mentions',
            },
          },
          {
            path: 'cgv',
            component: CgvComponent,
            data: {
              fullWidthNav: true,
              navbarTitleKey: 'cgu.mentions',
            },
          },
          {
            path: 'mentions',
            component: MentionsComponent,
            data: {
              fullWidthNav: true,
              navbarTitleKey: 'cgu.mentions',
            },
          },
          {
            path: 'confidentiality',
            component: ConfidentialityComponent,
            data: {
              fullWidthNav: true,
              navbarTitleKey: 'cgu.mentions',
            },
          },
        ],
      },
      {
        path: 'pricing',
        component: PricingPublicComponent,
        canActivate: [IsDesktopGuard, GuestGuard],
        children: [
          {
            path: '',
            component: PricingPremiumComponent,
            data: {
              fullWidthNav: true,
            },
          },
        ],
      },
      {
        path: 'testimonies',
        component: PublicTestimoniesComponent,
        canActivate: [IsDesktopGuard, GuestGuard],
        data: {
          navbarTitleKey: 'livreor.temoignages',
          navbarTitleMetadata: { siteName: environment.site_name },
        },
      },
    ]),
  ],
  declarations: [
    RegisterFromLandingComponent,
    LegalComponent,
    PricingPublicComponent,
    PublicTestimoniesComponent,
    PublicFooterComponent,
    CguComponent,
    CgvComponent,
    MentionsComponent,
    ConfidentialityComponent,
    LandingV2Component,
    LandingPassComponent,
    LandingPassFaqComponent,
  ],
  exports: [RouterModule],
})
export class LandingModule {}
